import { ApolloProvider } from '@apollo/client';
import PropTypes from 'prop-types';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { BrowserRouter } from 'react-router-dom';

import config from '../config/default.json';
import client from './lib/apolloClient';
import { createGrowthBookClient } from './lib/growthbook/client';
import { GrowthBookProvider } from './lib/growthbook/provider';
import queryClient from './lib/queryClient';

const { isDevelopment } = config;

const growthbookClient = createGrowthBookClient();
growthbookClient.init();

export function AppProviders({ children }) {
  return (
    <GrowthBookProvider client={growthbookClient}>
      <ApolloProvider client={client}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>{children}</BrowserRouter>
          {isDevelopment && <ReactQueryDevtools />}
        </QueryClientProvider>
      </ApolloProvider>
    </GrowthBookProvider>
  );
}

AppProviders.propTypes = {
  children: PropTypes.node.isRequired,
};
